import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DistributionHouseView from './components/DistributionHouseView';
import HighBalanceAgentsView from './components/HighBalanceAgentsView';
import ActiveAgentsView from './components/ActiveAgentsView';
import WithoutDisbursementCashoutView from './components/WithoutDisbursementCashoutView';
import PartnerPaymentView from './components/PartnerPaymentView';
import DhStockBalanceLiftingView from './components/DhStockBalanceLiftingView';
import DhStockProgressView from './components/DhStockProgressView';
import DhStockBalanceAgentView from './components/DhStockBalanceAgentView';
import AgentWithTransactionView from './components/AgentWithTransactionView';
import LeadingAgentsView from './components/LeadingAgentsView';
import LeadingAgentTpvView from './components/LeadingAgentTpvView';
import LeadingAgentCategoryView from './components/LeadingAgentCategoryView';
import MilkingAgentsView from './components/MilkingAgentsView';
import PartnerUpdateView from './components/PartnerUpdateView';
import PartnerTransactionView from './components/PartnerTransactionView';
import { fetch_help_summary } from './actions';
import { getHelpSummary } from './reducers';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content'
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120
  },
  formControlLabel: {
    marginTop: theme.spacing.unit
  }
});

const renderFilteringView = (filteringState, summary) => {
  if (filteringState.distribution_house && filteringState.high_balance_agents)
    return (
      <React.Fragment>
        <DistributionHouseView />
        <HighBalanceAgentsView summary={summary} />
      </React.Fragment>
    );
  else if (filteringState.distribution_house) return <DistributionHouseView />;
  else if (filteringState.high_balance_agents)
    return <HighBalanceAgentsView summary={summary} />;
  else if (filteringState.active_agents) return <ActiveAgentsView />;
  else if (filteringState.active_agent_without_disbursement_cashout)
    return <WithoutDisbursementCashoutView />;
  else if (filteringState.active_agent_partner_payment_only)
    return <PartnerPaymentView />;
  else if (filteringState.dh_stock_balance_lifting)
    return <DhStockBalanceLiftingView />;
  else if (filteringState.dh_stock_progress) return <DhStockProgressView />;
  else if (filteringState.dh_stock_balance_agent)
    return <DhStockBalanceAgentView />;
  else if (filteringState.agent_with_transaction)
    return <AgentWithTransactionView summary={summary} />;
  else if (filteringState.leading_agents)
    return <LeadingAgentsView summary={summary} />;
  else if (filteringState.leading_agent_tpv) return <LeadingAgentTpvView />;
  else if (filteringState.leading_agent_category)
    return <LeadingAgentCategoryView summary={summary} />;
  else if (filteringState.milking_agent)
    return <MilkingAgentsView summary={summary} />;
  else if (filteringState.partner_update) return <PartnerUpdateView />;
  else if (filteringState.partner_transaction)
    return <PartnerTransactionView />;
};

const MaxWidthDialog = props => {
  const dispatch = useDispatch();
  const summary = useSelector(getHelpSummary);

  const handleClose = () => {
    props.onClickClose();
  };

  useEffect(() => {
    dispatch(fetch_help_summary());
  }, []);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {renderFilteringView(props.state, summary)}
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MaxWidthDialog);
